// The placeholder icon in the header componenet, next the 'nom' and 'prénom'
export const profileLogoSvg = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9579 19.8C9.69474 20.2632 8.52632 20.8947 7.45263 21.6947C6.67368 20.8316 6.05263 19.8316 5.58947 18.6947C5.12632 17.5579 4.89474 16.3263 4.89474 15C4.89474 12.2 5.87916 9.81558 7.848 7.84674C9.816 5.87874 12.2 4.89474 15 4.89474C17.8 4.89474 20.1844 5.87874 22.1533 7.84674C24.1213 9.81558 25.1053 12.2 25.1053 15C25.1053 16.3263 24.8737 17.5579 24.4105 18.6947C23.9474 19.8316 23.3263 20.8316 22.5474 21.6947C21.4737 20.8947 20.3053 20.2632 19.0421 19.8C17.7789 19.3368 16.4316 19.1053 15 19.1053C13.5684 19.1053 12.2211 19.3368 10.9579 19.8ZM12.0796 14.7625C12.8686 15.5524 13.8421 15.9474 15 15.9474C16.1579 15.9474 17.1314 15.5524 17.9204 14.7625C18.7103 13.9735 19.1053 13 19.1053 11.8421C19.1053 10.6842 18.7103 9.71074 17.9204 8.92168C17.1314 8.13179 16.1579 7.73684 15 7.73684C13.8421 7.73684 12.8686 8.13179 12.0796 8.92168C11.2897 9.71074 10.8947 10.6842 10.8947 11.8421C10.8947 13 11.2897 13.9735 12.0796 14.7625ZM10.3112 26.0526C11.7739 26.6842 13.3368 27 15 27C16.6632 27 18.2265 26.6842 19.6901 26.0526C21.1528 25.4211 22.4211 24.5684 23.4947 23.4947C24.5684 22.4211 25.4211 21.1524 26.0526 19.6888C26.6842 18.2261 27 16.6632 27 15C27 13.3368 26.6842 11.7735 26.0526 10.3099C25.4211 8.84716 24.5684 7.57895 23.4947 6.50526C22.4211 5.43158 21.1528 4.57895 19.6901 3.94737C18.2265 3.31579 16.6632 3 15 3C13.3368 3 11.7739 3.31579 10.3112 3.94737C8.84758 4.57895 7.57895 5.43158 6.50526 6.50526C5.43158 7.57895 4.57895 8.84716 3.94737 10.3099C3.31579 11.7735 3 13.3368 3 15C3 16.6632 3.31579 18.2261 3.94737 19.6888C4.57895 21.1524 5.43158 22.4211 6.50526 23.4947C7.57895 24.5684 8.84758 25.4211 10.3112 26.0526ZM18.3006 24.552C17.2371 24.9208 16.1368 25.1053 15 25.1053C13.8632 25.1053 12.7629 24.9208 11.6994 24.552C10.6366 24.184 9.69474 23.6737 8.87368 23.0211C9.69474 22.3684 10.6265 21.8686 11.6691 21.5217C12.7107 21.1739 13.8211 21 15 21C16.1789 21 17.2893 21.1789 18.3309 21.5368C19.3735 21.8947 20.3053 22.3895 21.1263 23.0211C20.3053 23.6737 19.3634 24.184 18.3006 24.552ZM16.5789 13.4211C16.1579 13.8421 15.6316 14.0526 15 14.0526C14.3684 14.0526 13.8421 13.8421 13.4211 13.4211C13 13 12.7895 12.4737 12.7895 11.8421C12.7895 11.2105 13 10.6842 13.4211 10.2632C13.8421 9.8421 14.3684 9.63158 15 9.63158C15.6316 9.63158 16.1579 9.8421 16.5789 10.2632C17 10.6842 17.2105 11.2105 17.2105 11.8421C17.2105 12.4737 17 13 16.5789 13.4211Z"
      fill="#003E5C"
    />
  </svg>
);

//* Buttons
// The left icon on the 'Modifier' button
export const crayonIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.885 15.6773H4.781V14.5943L12.323 7.05226L12.864 7.61526L13.406 8.15626L5.885 15.6773ZM13.218 4.21926L16.218 7.23926L17.156 6.30226C17.42 6.05226 17.552 5.73626 17.552 5.35426C17.552 4.97226 17.427 4.64926 17.177 4.38526L16.239 3.44826C15.9337 3.14226 15.5623 2.98926 15.125 2.98926C14.687 2.98926 14.3083 3.14226 13.989 3.44826L13.218 4.21926ZM6.448 17.0103L15.302 8.15626L12.302 5.15626L3.448 14.0103V17.0103H6.448Z"
      fill="#003E5C"
    />
  </svg>
);

// valider button icon

export const validerButtonIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_2561_3540"
      maskUnits="userSpaceOnUse"
      x="3.5835"
      y="0.708007"
      width="13"
      height="19"
      fill="black"
    >
      <rect fill="white" x="3.5835" y="0.708007" width="13" height="19" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4165 10L6.7085 2.29201L5.5835 3.41701L12.1875 10L5.5835 16.583L6.7085 17.708L14.4165 10Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4165 10L6.7085 2.29201L5.5835 3.41701L12.1875 10L5.5835 16.583L6.7085 17.708L14.4165 10Z"
      fill="white"
    />
    <path
      d="M6.7085 2.29201L7.4156 1.5849L6.7085 0.877794L6.00139 1.5849L6.7085 2.29201ZM14.4165 10L15.1236 10.7071L15.8307 10L15.1236 9.2929L14.4165 10ZM5.5835 3.41701L4.87639 2.7099L4.16815 3.41813L4.87752 4.12524L5.5835 3.41701ZM12.1875 10L12.8935 10.7082L13.604 10L12.8935 9.29178L12.1875 10ZM5.5835 16.583L4.87752 15.8748L4.16816 16.5819L4.87639 17.2901L5.5835 16.583ZM6.7085 17.708L6.00139 18.4151L6.7085 19.1222L7.4156 18.4151L6.7085 17.708ZM6.00139 2.99911L13.7094 10.7071L15.1236 9.2929L7.4156 1.5849L6.00139 2.99911ZM6.2906 4.12411L7.4156 2.99911L6.00139 1.5849L4.87639 2.7099L6.2906 4.12411ZM12.8935 9.29178L6.28948 2.70878L4.87752 4.12524L11.4815 10.7082L12.8935 9.29178ZM6.28948 17.2912L12.8935 10.7082L11.4815 9.29178L4.87752 15.8748L6.28948 17.2912ZM7.4156 17.0009L6.2906 15.8759L4.87639 17.2901L6.00139 18.4151L7.4156 17.0009ZM13.7094 9.2929L6.00139 17.0009L7.4156 18.4151L15.1236 10.7071L13.7094 9.2929Z"
      fill="white"
      mask="url(#path-1-outside-1_2561_3540)"
    />
  </svg>
);

// Envoyer votre inscription button icon

export const envoyerVotreInscriptionIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9998 10.25L4 4.25V16.25L17.9998 10.25ZM14.8662 10.25L5.22092 14.3879V11.3259L7.64275 10.7358C8.1516 10.6118 8.1516 9.88819 7.64275 9.76421L5.22092 9.17414V6.11207L14.8662 10.25Z"
      fill="white"
    />
  </svg>
);

// The left icon on the 'Télécharger' button

export const telechargerIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.025 17.0626C3.375 17.4126 3.8 17.5876 4.3 17.5876H15.7C16.2 17.5876 16.625 17.4126 16.975 17.0626C17.325 16.7126 17.5 16.2876 17.5 15.7876V13.0876H16V15.7876C16 15.8543 15.9667 15.9209 15.9 15.9876C15.8333 16.0543 15.7667 16.0876 15.7 16.0876H4.3C4.23333 16.0876 4.16667 16.0543 4.1 15.9876C4.03333 15.9209 4 15.8543 4 15.7876V13.0876H2.5V15.7876C2.5 16.2876 2.675 16.7126 3.025 17.0626ZM5.725 9.4376L10 13.7126L14.275 9.4376L13.225 8.3376L10.75 10.8126V2.4126H9.25V10.8126L6.775 8.3376L5.725 9.4376Z"
      fill="#00AEC3"
    />
  </svg>
);

export const telechargerBlueIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    //xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.025 17.0626C3.375 17.4126 3.8 17.5876 4.3 17.5876H15.7C16.2 17.5876 16.625 17.4126 16.975 17.0626C17.325 16.7126 17.5 16.2876 17.5 15.7876V13.0876H16V15.7876C16 15.8543 15.9667 15.9209 15.9 15.9876C15.8333 16.0543 15.7667 16.0876 15.7 16.0876H4.3C4.23333 16.0876 4.16667 16.0543 4.1 15.9876C4.03333 15.9209 4 15.8543 4 15.7876V13.0876H2.5V15.7876C2.5 16.2876 2.675 16.7126 3.025 17.0626ZM5.725 9.4376L10 13.7126L14.275 9.4376L13.225 8.3376L10.75 10.8126V2.4126H9.25V10.8126L6.775 8.3376L5.725 9.4376Z"
      fill="#fff"
    />
  </svg>
);

// White Check icon

export const whiteCheckIcon = (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 7.3501L6.05 11.6501L16.275 1.4251L15.225 0.350098L6.05 9.5251L1.775 5.2501L0.724998 6.3251L1.725 7.3251V7.3501H1.75Z"
      fill="white"
    />
  </svg>
);

//* Notification
// Success status icon

export const successIcon = (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.20039 13.2496L13.8248 7.65039L12.8996 6.72519L8.20039 11.4004L6.07519 9.30039L5.14999 10.2256L8.20039 13.2496ZM9.49999 19.0996C8.25039 19.0996 7.07119 18.8624 5.96239 18.388C4.85439 17.9128 3.88759 17.2628 3.06199 16.438C2.23719 15.6124 1.58719 14.6456 1.11199 13.5376C0.637591 12.4288 0.400391 11.2496 0.400391 9.99999C0.400391 8.73359 0.637591 7.55039 1.11199 6.45039C1.58719 5.35039 2.23719 4.38759 3.06199 3.56199C3.88759 2.73719 4.85439 2.08719 5.96239 1.61199C7.07119 1.13759 8.25039 0.900391 9.49999 0.900391C10.7664 0.900391 11.9496 1.13759 13.0496 1.61199C14.1496 2.08719 15.1124 2.73719 15.938 3.56199C16.7628 4.38759 17.4128 5.35039 17.888 6.45039C18.3624 7.55039 18.5996 8.73359 18.5996 9.99999C18.5996 11.2496 18.3624 12.4288 17.888 13.5376C17.4128 14.6456 16.7628 15.6124 15.938 16.438C15.1124 17.2628 14.1496 17.9128 13.0496 18.388C11.9496 18.8624 10.7664 19.0996 9.49999 19.0996ZM9.49999 17.8C11.6664 17.8 13.508 17.0416 15.0248 15.5248C16.5416 14.008 17.3 12.1664 17.3 9.99999C17.3 7.83359 16.5416 5.99199 15.0248 4.47519C13.508 2.95839 11.6664 2.19999 9.49999 2.19999C7.33359 2.19999 5.49199 2.95839 3.97519 4.47519C2.45839 5.99199 1.69999 7.83359 1.69999 9.99999C1.69999 12.1664 2.45839 14.008 3.97519 15.5248C5.49199 17.0416 7.33359 17.8 9.49999 17.8Z"
      fill="white"
    />
  </svg>
);

//* Etablissement - Récapitulatif de votre inscription - page

// Icon inside the 'Envoyer votre inscription' button
export const flecheDroiteIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4998 10.75L3.5 4.75V16.75L17.4998 10.75ZM14.3662 10.75L4.72092 14.8879V11.8259L7.14275 11.2358C7.6516 11.1118 7.6516 10.3882 7.14275 10.2642L4.72092 9.67414V6.61207L14.3662 10.75Z"
      fill="white"
    />
  </svg>
);

// Minus icon ( - )displayed inside the jourbox when the jour indisponible

export const minusIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9V11H17V9H3Z"
      fill="#003E5C"
    />
  </svg>
);

//* Etablissement - Demande envoyéee - page

// Check icon on top of the page
export const checkIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="15.5" fill="white" stroke="#003E5C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2501 21.3501L17.5501 25.6501L27.7751 15.4251L26.7251 14.3501L17.5501 23.5251L13.2751 19.2501L12.2251 20.3251L13.2251 21.3251V21.3501H13.2501Z"
      fill="#003E5C"
    />
  </svg>
);

//* Popups

export const closeIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.17856 10L0.58928 17.5893L2.41071 19.4107L9.99999 11.8214L17.5893 19.4107L19.4107 17.5893L11.8214 10L19.4107 2.41071L17.5893 0.589282L9.99999 8.17857L2.41071 0.589288L0.589283 2.41072L8.17856 10Z"
      fill="#AFAFAF"
    />
  </svg>
);
<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clip-rule="evenodd"
    d="M8.17856 10L0.58928 17.5893L2.41071 19.4107L9.99999 11.8214L17.5893 19.4107L19.4107 17.5893L11.8214 10L19.4107 2.41071L17.5893 0.589282L9.99999 8.17857L2.41071 0.589288L0.589283 2.41072L8.17856 10Z"
    fill="#AFAFAF"
  />
</svg>;

//* PageNotFound

// Left arrow icon on the 'Revenir à la page d'accueil button'

export const leftArrowIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11L10 16L11.062 14.938L6.875 10.75H16V9.25H6.875L11.062 5.062L10 4L4 10L5 11Z"
      fill="#003E5C"
    />
  </svg>
);

// * Metier jour box
export const plusCounterIcon = (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 7.75V14H8.5V7.75H14.75V6.25H8.5V0H7V6.25H0.75V7.75H7Z"
      fill="#003E5C"
    />
  </svg>
);

export const minusCounterIcon = (
  <svg
    width="14"
    height="2"
    viewBox="0 0 14 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V2H14V0H0Z"
      fill="#003E5C"
    />
  </svg>
);
